import React from "react";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import AdminTopNav from "components/navigations/AdminNavs/AdminTopNav";
import EmployerMainNav from "components/navigations/EmployerNavs/EmployerMainNav";
import RecruiterTopNav from "components/navigations/RecruiterTopNav";
import RecruiterClusterNav from "components/navigations/RecruiterNavs/RecruiterClusterNav";
import ErrorPage from "pages/ErrorPage/ErrorPage";
import AdminSideClientNav from "components/navigations/AdminNavs/AdminSideClientNav";

export default function OrderLayerBlueprint(WrappedComponent) {
  return function OrderLayerComponent(props) {
    const appContext = useAppContext();
    const { account } = appContext;
    const { accountType } = account;

    if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
      return (
        <div className="min-h-screen max-h-screen">
          <AdminTopNav />
          <AdminSideClientNav />
          <section className="relative top-[60px]">
            <WrappedComponent {...props} />
          </section>
        </div>
      );
    } else if (accountType.type === ACCOUNT_TYPES.RECRUITER.type) {
      return (
        <div className="min-h-screen max-h-screen">
          <RecruiterTopNav />
          <RecruiterClusterNav />
          <div className="relative top-[50px]">
            <WrappedComponent {...props} />
          </div>
        </div>
      );
    } else if (accountType.type === ACCOUNT_TYPES.EMPLOYER_PRIVATE.type) {
      return (
        <div className="min-h-screen max-h-screen">
          <EmployerMainNav />
          <section className="relative top-[50px]">
            <h2>Employer Wrapper</h2>
            <WrappedComponent {...props} />
          </section>
        </div>
      );
    } else if (accountType.type === ACCOUNT_TYPES.EMPLOYER_PUBLIC.type) {
      return (
        <div className="min-h-screen max-h-screen">
          <EmployerMainNav />
          <section className="relative top-[50px]">
            <WrappedComponent {...props} />
          </section>
        </div>
      );
    } else return <ErrorPage />;
  };
}
